import React, { Component } from "react";
import "./App.css";

import brace from "brace";
import AceEditor from "react-ace";

import "brace/mode/markdown";
import "brace/theme/solarized_light";

import { toText, toHtml } from "./MarkdownRenderers";

const LOCAL_STORAGE_KEY = "edraft";

const defaultBody = `Hello!

This is a simple markdown email drafting tool that automatically composes sane versions of your email in plaintext and HTML.

I, Christian Genco, made it primarily to deal with rendering links in plain text.

Here's an example

* [Christian Genco's website](https://gen.co)
* [Google](https://google.com)

And an example of embedding an image:

![lolcat](https://i.imgur.com/3QlO536.jpg)

I don't have any plans right now to turn this into anything fancy, but if you have any suggestions I'd love to hear them! Tweet me @cgenco, or contact me through [my website](https://christian.gen.co).

Christian.`;

class App extends Component {
  state = {
    body: localStorage.getItem(LOCAL_STORAGE_KEY) || defaultBody,
  };

  componentDidMount() {}

  render() {
    const { body } = this.state;

    const html = toHtml(body);
    const plaintext = toText(body);

    return (
      <div style={{ display: "flex" }}>
        <AceEditor
          style={{ flex: 1, height: "100vh" }}
          mode="markdown"
          theme="solarized_light"
          onLoad={() => {}}
          onChange={body => {
            localStorage.setItem(LOCAL_STORAGE_KEY, body);
            this.setState({ body });
          }}
          fontSize={14}
          showPrintMargin={true}
          showGutter={true}
          highlightActiveLine={true}
          wrapEnabled={true}
          value={body}
          setOptions={{
            enableBasicAutocompletion: false,
            enableLiveAutocompletion: false,
            enableSnippets: false,
            showLineNumbers: true,
            tabSize: 2,
          }}
        />
        <textarea style={{ flex: 1 }} value={plaintext} />
        <textarea style={{ flex: 1 }} value={html} />
        {/* <div style={{ flex: 1, padding: 10 }}>
          <Markdown source={body} style={{ flex: 1 }} />
        </div> */}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js